module.exports = __webpack_public_path__ + "img/capa2.837c35f2.webp";